import React from 'react';
import AttachmentIcon from '../../assets/icons/attachment.svg';
import { Message, Priority } from '../../models/communication.types';
import PriorityMediumIcon from './PriorityMediumIcon.component';
import PriorityHighIcon from './PriorityHighIcon.component';
import LinkIcon from '@mui/icons-material/Link';

interface MessageMonitProps {
  message: Message;
}

const iconStyle = { margin: '0 3px 0 3px' };

const MessageMonit: React.FC<MessageMonitProps> = ({ message }) => {
  return (
    <>
      {message.priorityId === Priority.Medium && <PriorityMediumIcon />}
      {message.priorityId === Priority.High && <PriorityHighIcon />}
      {message.hasAttachment && <img src={AttachmentIcon} style={iconStyle} alt="Wiadomość zawiera załącznik" />}
      {message.hasUrl && <LinkIcon style={{ height: '16px', color: '#565765' }} />}
    </>
  );
};

export default MessageMonit;
